import React from "react";

import "./statuscard.css";

const StatusCard = (props) => {
  return (
    <div style={props.style} className="status-card">
      <div className="status-card__info">
        <span className="desc">{props.title}</span>
        <h2 className="mt-3">{props.count ? props.count : "0"}</h2>
      </div>
    </div>
  );
};

export default StatusCard;
